// Import model
import { DataviewCatalogItemResponse } from '../models/DataviewCatalogItemResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { CatalogItem } from '../models/CatalogItem';
import { DataView } from '../models/DataView';
import { FilterCatalogItemRequest } from '../models/FilterCatalogItemRequest';

// Import dependency serializers (for complex types)
import { CatalogItemSerializer } from './CatalogItemSerializer';
import { DataViewSerializer } from './DataViewSerializer';
import { FilterCatalogItemRequestSerializer } from './FilterCatalogItemRequestSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for DataviewCatalogItemResponse - handles JSON serialization and deserialization with type validation
 */
export class DataviewCatalogItemResponseSerializer {
  /**
   * Deserializes a JSON string into a DataviewCatalogItemResponse instance
   */
  static deserialize(json: string): DataviewCatalogItemResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a DataviewCatalogItemResponse instance
   */
  static fromObject(obj: any): DataviewCatalogItemResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to DataviewCatalogItemResponse');
    }


    const instance: DataviewCatalogItemResponse = {
      result: obj['Result'] ? (obj['Result'] as any[]).map((item: any) =>
        CatalogItemSerializer.fromObject(item)
      ) : [] as any,
      request: obj['Request'] ? FilterCatalogItemRequestSerializer.fromObject(obj['Request']) : undefined as any,
      dataView: obj['DataView'] ? DataViewSerializer.fromObject(obj['DataView']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of DataviewCatalogItemResponse instances
   */
  static deserializeArray(json: string): DataviewCatalogItemResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a DataviewCatalogItemResponse instance to a JSON string
   */
  static serialize(instance: DataviewCatalogItemResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a DataviewCatalogItemResponse instance to a plain object
   */
  static toObject(instance: DataviewCatalogItemResponse): any {
    return {
      'Result': instance.result?.map((item: any) =>
        CatalogItemSerializer.toObject(item)
      ),
      'Request': instance.request ? FilterCatalogItemRequestSerializer.toObject(instance.request) : undefined,
      'DataView': instance.dataView ? DataViewSerializer.toObject(instance.dataView) : undefined,
    };
  }

  /**
   * Serializes an array of DataviewCatalogItemResponse instances to a JSON string
   */
  static serializeArray(instances: DataviewCatalogItemResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
